import React, { useState, useCallback, useContext } from "react";
import { Form, Input, Modal, notification, Radio } from "antd";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import ServiceApi from "../../../../services/ServiceApi";
import { approveExclusion } from "../../../../actions/jobDetailAction";
import { authUserContext } from "../../../../contexts/authContext";
import { StatusInfo } from "../../../../components/utility/status_info_modal";

// const formItemLayout = {
//   labelCol: { span: 6 },
//   wrapperCol: { span: 14 },
// };

const ModalApproveExclusion = ({ jobDetail, workFlow, visible, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [statusSuccess, setStatusSuccess] = useState("");
  const { jobExclusionList } = useSelector((state) => ({
    jobExclusionList: state.jobDetail.jobExclusionList,
  }));
  const jobExclusion = jobExclusionList.length > 0 ? jobExclusionList[0] : null;
  const authUserValue = useContext(authUserContext);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const handleApproveExclusion = useCallback(
    async (value) => {
      try {
        const res = await dispatch(approveExclusion(value));
        // console.log("useCallback", res);
        return res;
      } catch (err) {
        throw err;
      }
    },
    [dispatch]
  );

  const handleSubmit = (value) => {
    // console.log("jobDetail", jobDetail);
    // console.log("value", value);
    // return;
    setIsLoading(true);
    handleApproveExclusion({
      ...workFlow,
      job_id: jobDetail.job_id,
      company_id: jobDetail.company_id,
      operator_id: jobDetail.operator_id,
      project_id: jobDetail.project_id,
      job_exclusion_id: jobExclusion?.job_exclusion_id ?? 0,
      exclusion_result : value.exclusion_result,
      exclusion_status: value.exclusion_status,
      is_active: 1,
      update_date: moment(),
      // update_date: "2021-06-28",
      create_by: authUserValue.username,
      action_data_dynamic: undefined,
      // style_sheet_format: undefined,
    })
      .then((res) => {
        console.log("res handleSubmit", res);
        setIsLoading(false);
        if (res.result.value === "P") {
          notification.info({
            message: "Success",
            description: "Approve data success",
          });
          form.resetFields();
          setStatusSuccess("Approve data success");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 800);
        } else {
          notification.error({
            message: "Error",
            description: res.result?.showText,
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        notification.error({
          message: "Error",
          description: err.message,
        });
      });
  };
  return (
    <Modal
      title={null}
      centered
      visible={visible}
      footer={null}
      closable={false}
    >
      {isLoading || statusSuccess ? (
        <StatusInfo
          showSpinIcon={isLoading}
          hasError={statusSuccess}
          statusText={statusSuccess}
          callbackFunction={() => {
            window.location.reload();
          }}
        />
      ) : (
        <div className="modal-approve-exclusion">
          <div className="row d-flex justify-content-center">
            <img
              src={ServiceApi.absoluteUrl("/img/modal_approve.svg")}
              className="img-fluid"
              alt="approve"
            />
          </div>
          <div className="row d-flex justify-content-center">
            <span className="font-thai-b fs-22 c-blue">
              {`Approve งาน : ${jobDetail?.job_no} / ${jobDetail?.so_id}`}
            </span>
          </div>
          <Form
            onFinish={handleSubmit}
            form={form}
            // {...formItemLayout}
            layout="vertical"
            // hideRequiredMark="true"
          >
            <Form.Item name="exclusion_result" label="Remark">
              <Input.TextArea rows="2" />
            </Form.Item>
            <Form.Item
              name="exclusion_status"
              label="Exclusion Status"
              rules={[{ required: true, message: "Please pick Status!" }]}
            >
              <Radio.Group>
                <Radio value="Pass">Pass</Radio>
                <Radio value="Fail">Fail</Radio>
              </Radio.Group>
            </Form.Item>
          </Form>
          <div className="row d-flex justify-content-center mt-2">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
            <button className="btn btn-success" onClick={() => form.submit()}>
              Confirm
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ModalApproveExclusion;
